export default __webpack_public_path__ + "static/media/spare_parts_icon.4818fd46.png";